<template>
  <fragment>
    <v-col cols="12" class="p-5">
      <div class="p-5" style="max-width: 97vw">
        <p
          class="text-justify"
          v-html="_messageInfoService.getExplanation('copay', model.persontype)"
        ></p>
      </div>
    </v-col>
    <v-row class="ml-5 mb-3">
      <v-col
        class="col-12 col-sm-6 pb-0 pt-0"
        style="padding: 0px; margin: 0px"
        :key="'list-acc-' + ind"
        v-for="(acc, ind) in itens"
      >
        <v-switch
          :label="acc.label"
          placeholder=" "
          v-model="acc.check"
          class="switch-base"
          style="padding: 0px; margin: 0px"
          @change="setCopay(acc)"
        />
      </v-col>
    </v-row>
    <v-col cols="12" v-if="model.cooparticipacao && model.cooparticipacao.length > 0">
      <v-btn color="botao" @click="selecionar()" block>
        <v-icon small left>fas fa-check</v-icon>Continuar
      </v-btn>
    </v-col>
  </fragment>
</template>

<script>
import { mapMutations } from "vuex";
import InsurancePricingService from "../services/salesforce/InsurancePricingService";
import MessageInfoService from "../services/salesforce/MessageInfoService";
import store from "../store/store";
import { Fragment } from "vue-fragment";

export default {
  components: { Fragment },
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      itens: [],
    };
  },
  beforeCreate() {
    this._insurancePricingService = new InsurancePricingService();
    this._messageInfoService = new MessageInfoService();
  },
  mounted() {
    this.getItens();
  },
  methods: {
    ...mapMutations(["toogleDialogLoading"]),
    setCopay(item) {
      if (this.model.cooparticipacao.some((s) => s.label == item.label)) {
        this.model.cooparticipacao = this.model.cooparticipacao.filter(
          (f) => f.label != item.label
        );
      } else this.model.cooparticipacao.push(item);
    },
    selecionar() {
      this.$emit("selecionar");
    },
    SemDados() {
      this.$emit("semdados");
    },
    naoDisponivel() {
      store.commit("showmsg", {
        text: this._messageInfoService.getExplanation("nao-disponivel"),
        type: "warning",
      });
    },
    async getItens() {
      if (!(this.model.loadquote && this.model.loadquote)) {
        this.toogleDialogLoading(true);
      }
      await this._insurancePricingService
        .getCooparticipacao(this.model.region.Id, this.model.selectProjeto.id)
        .then((res) => {
          if (!res.data || res.data.length <= 0) {
            this.naoDisponivel();
            this.SemDados();
          } else {
            this.itens = res.data;
            if (this.model.loadquote && this.model.cooparticipacao) {
              this.model.cooparticipacao.forEach((acc) => {
                if (acc.check) {
                  this.itens.forEach((item) => {
                    if (item.label == acc.label) {
                      item.check = true;
                    }
                  });
                }
              });
              this.selecionar();
            } else {
              this.model.cooparticipacao = [];
            }
          }
        })
        .finally(() => {
          if (!(this.model.loadquote && this.model.loadquote)) {
            this.toogleDialogLoading(false);
          }
        });
    },
  },
};
</script>
